import PoweredBy from '@/components/decoration/PoweredBy';
import { useCanShowBrandedLogo } from '@/components/decoration/mspLogoHelper';
import { Account } from '@/layouts/header/Account';
import { motion } from 'framer-motion';
import { FunctionComponent } from 'react';
import { Settings } from './settings/Settings';

interface RightHandSideNavSectionProps {}

const RightHandSideNavSection: FunctionComponent<RightHandSideNavSectionProps> = () => {
  const canShowBrandedLogo = useCanShowBrandedLogo();

  return canShowBrandedLogo ? (
    <motion.div layoutId="rightHandSide" className="flex space-x-10">
      <PoweredBy />
      <div className="flex space-x-2">
        {/*<NotificationBell />*/}
        <Settings />
        <Account />
      </div>
    </motion.div>
  ) : (
    <motion.div layoutId="rightHandSide" className="flex space-x-2">
      {/*<NotificationBell />*/}
      <Settings />
      <Account />
    </motion.div>
  );
};

export default RightHandSideNavSection;
